<template>
  <ul class="cascader-list" @click.stop="">
    <li class="no-result" v-if="noListMsg && !list.length">{{noListMsg}}</li>
    <li v-for="(item, index) in list" :key="index" class="cascader-list-item" :class="{'is-active': currentValue && item[props.value] === currentValue[props.value]}" @click="itemClick(item)">
      <slot :item="item" :selected="currentValue">
        {{ item[props.label] }}
      </slot>
    </li>
  </ul>
</template>

<style type="text/css">

.is-title-mode .cascader-list {
  width: 100%;
}

.cascader-list {
  display: inline-block;
  vertical-align: top;
  overflow: auto;
  height: 200px;
  width: 100%;
  padding: 8px 0;
}

.cascader-list-item {
  padding: 8px 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  &.is-active {
    background-color: #f5f5f5;
  }
}

.no-result {
  text-align: center;
  padding-top: 30px;
  height: 100%;
}
</style>

<script type="text/javascript">

export default {
  props: {
    initList: Array,
    props: {
      type: Object,
      default () {
        return {
          value: 'value',
          label: 'label',
          children: 'children'
        };
      }
    },
    noListMsg: String,
    list: Array,
    value: Object,
    canCancel: Boolean
  },

  computed: {
    currentValue: {
      get () {
        return this.value;
      },

      set (v) {
        this.$emit('input', v);
      }
    }
  },

  methods: {
    itemClick (item) {
      if (item !== this.currentValue) {
        this.currentValue = item;
        this.$emit('change', item);
        return;
      }

      if (this.canCancel) {
        this.currentValue = null;
        this.$emit('change', null);
      }
    }
  }
};
</script>
